import { Box, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { formateDateDDMMYY } from "../../Services/formatDate";
import { theme } from "../../Assets/Theme/theme";
import CustomCalendar from "../Common/CustomCalendar";
import Dropdown from "../../AdminComponents/Common/Dropdown";
import CheckoutButton from "../Common/CheckoutButton";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCart } from "../../Services/CartContext";

function AddToCart({ data, dateData }) {
  const navigate = useNavigate();
  const checkoutRef = useRef(null);

  const { cart, addToCart, setCart } = useCart();

  const [cartData, setCartData] = useState({
    date: "",
    timeSlot: null,
    convertedsymbol:
      data?.priceCategories?.[0]?.prices?.[0]?.convertedsymbol || "$",
    ageCounts: {},
  });
  const [errors, setErrors] = useState([]);

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token;

  useEffect(() => {
    if (!cartData.date) {
      const today = new Date();
      setCartData((prev) => ({
        ...prev,
        date: formateDateDDMMYY(today),
      }));
    }
  }, []);

  const handleIncrement = (ageCategoryName) => {
    setCartData((prev) => ({
      ...prev,
      ageCounts: {
        ...prev.ageCounts,
        [ageCategoryName]: (prev.ageCounts[ageCategoryName] || 0) + 1,
      },
    }));
  };

  const handleDecrement = (ageCategoryName) => {
    setCartData((prev) => ({
      ...prev,
      ageCounts: {
        ...prev.ageCounts,
        [ageCategoryName]:
          prev.ageCounts[ageCategoryName] > 0
            ? prev.ageCounts[ageCategoryName] - 1
            : 0,
      },
    }));
  };

  const handleDateChange = (date) => {
    setCartData((prev) => ({
      ...prev,
      date: formateDateDDMMYY(date),
    }));

    setTimeout(() => {
      checkoutRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 300);
  };

  const handleTimeSlotSelect = (timeSlot) => {
    const selectedTimeSlot = data?.priceCategories?.find(
      (slot) => slot.timeSlot === timeSlot
    );

    const convertedsymbol =
      selectedTimeSlot?.prices?.[0]?.convertedsymbol || "$";

    const ageCounts = {};
    selectedTimeSlot?.prices?.forEach((price) => {
      const ageName = price.age.name;
      if (!ageCounts[ageName]) {
        ageCounts[ageName] = 0;
      }
    });

    setCartData((prev) => ({
      ...prev,
      timeSlot,
      convertedsymbol,
      ageCounts,
    }));
  };

  // Create dropdown options from available time slots
  const getTimeSlotOptions = () => {
    return data?.priceCategories
      ?.filter((slot) => slot.timeSlot.trim() !== "" && slot.timeSlot.trim() !== " ")
      ?.map((slot) => ({
        value: slot.timeSlot,
        label: slot.timeSlot,
      })) || [];
  };

  const handleTimeSlotChange = (e) => {
    const selectedTimeSlot = e.target.value;
    handleTimeSlotSelect(selectedTimeSlot);
    clearErrorMessage("timeSlot");
  };

  const getPrice = (ageCategoryName) => {
    let selectedCategory = cartData?.timeSlot
      ? data?.priceCategories?.find(
          (slot) => slot?.timeSlot === cartData?.timeSlot
        )
      : data?.priceCategories?.[0];

    if (!selectedCategory) return 0;

    const allPriceInfo = selectedCategory?.prices?.find(
      (price) => price?.age?.name?.toLowerCase() === "all"
    );
    if (allPriceInfo) {
      return (
        allPriceInfo?.convertsalePrice ||
        allPriceInfo?.convertedPrice ||
        allPriceInfo?.originalPrice ||
        0
      );
    }

    const priceInfo = selectedCategory?.prices?.find(
      (price) =>
        price?.age?.name?.toLowerCase() === ageCategoryName.toLowerCase()
    );

    return (
      priceInfo?.convertsalePrice ||
      priceInfo?.convertedPrice ||
      priceInfo?.originalPrice ||
      0
    );
  };

  let { adults, children, senior } = cartData;
  const allCount = cartData.all || 0;

  if (allCount > 0) {
    const totalCategories = 3;
    const share = Math.floor(allCount / totalCategories);
    adults += share;
    children += share;
    senior += share;

    const remainder = allCount % totalCategories;
    if (remainder > 0) adults += remainder;
  }

  const adultPrice = getPrice("adult");
  const childPrice = getPrice("child");
  const seniorPrice = getPrice("senior");

  const total = Object.entries(cartData.ageCounts)
    .reduce((acc, [ageName, count]) => acc + count * getPrice(ageName), 0)
    .toFixed(2);

  const handleCheckout = async () => {
    const formattedDate = cartData.date.replace(/\//g, "-");
    const headers = {};

    let ageCategories = [];

    let selectedTimeSlot = data?.priceCategories?.find(
      (slot) => slot?.timeSlot === cartData?.timeSlot
    );

    if (
      !selectedTimeSlot &&
      (cartData?.timeSlot === null || cartData?.timeSlot === undefined)
    ) {
      selectedTimeSlot = data?.priceCategories?.find(
        (slot) => slot?.timeSlot === "" || slot?.timeSlot === " "
      );

      if (!selectedTimeSlot && data?.priceCategories?.length > 0) {
        selectedTimeSlot = data.priceCategories[0];
      }
    }

    if (selectedTimeSlot) {
      for (const [ageName, count] of Object.entries(cartData.ageCounts)) {
        if (count > 0) {
          let categoryId = null;

          const allPrice = selectedTimeSlot.prices.find(
            (price) => price.age?.name?.toLowerCase() === "all"
          );

          if (allPrice) {
            categoryId = allPrice.id;
          } else {
            const specificPrice = selectedTimeSlot.prices.find(
              (price) =>
                price.age?.name?.toLowerCase() === ageName.toLowerCase()
            );
            console.log(specificPrice, "SPECIFIC PRICE");

            categoryId = specificPrice?.age?._id;
          }

          if (categoryId) {
            ageCategories.push({
              name: categoryId,
              count,
              id: categoryId,
            });
          }
        }
      }
    }
    if (
      ageCategories.length === 0 &&
      Object.keys(cartData.ageCounts).length > 0 &&
      selectedTimeSlot
    ) {
      const firstAvailablePrice = selectedTimeSlot.prices[0];
      console.log(selectedTimeSlot, "CHECK");
      if (firstAvailablePrice) {
        const firstAgeName = Object.keys(cartData.ageCounts)[0];
        const count = cartData.ageCounts[firstAgeName];

        ageCategories.push({
          name: firstAvailablePrice.id,
          count,
          id: firstAvailablePrice.id,
        });
      }
    }

    const timeSlotToSend = cartData.timeSlot === null ? " " : cartData.timeSlot;

    const payload = {
      experienceId: data._id,
      name: data?.name,
      ageCategories,
      timeSlot: timeSlotToSend,
      date: formattedDate,
      total,
      userType: token ? "Registered" : "Guest",
      currency: cartData.convertedsymbol,
    };

    console.log("Payload for API:", payload);

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    try {
      if (ageCategories.length === 0) {
        throw new Error("Please select at least one ticket");
      }

      const response = await axios.post(
        `${BASE_URL}/user/booking/step1`,
        payload,
        { headers }
      );

      navigate(token ? "/checkout" : "/fillForm", {
        state: {
          bookingData: response.data,
          name: data?.name,
          location: data?.country_city,
        },
      });

      toast.success(response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: "orange", color: "white" },
      });
    } catch (error) {
      console.error("Checkout Error:", error?.response?.data || error);

      let errorMessages = [];

      if (error instanceof Error && !error.response) {
        errorMessages = [{ path: "ageCategories", msg: error.message }];
      } else if (Array.isArray(error?.response?.data?.error)) {
        errorMessages = error.response.data.error.map((err) => {
          if (err && typeof err.msg === "object") {
            return { ...err, msg: JSON.stringify(err.msg) };
          }
          return err;
        });
      } else if (error?.response?.data?.error) {
        let errMsg = error.response.data.error;
        if (typeof errMsg === "object") {
          errMsg = JSON.stringify(errMsg);
        }
        errorMessages = [{ path: "ageCategories", msg: errMsg }];
      } else {
        errorMessages = [
          { path: "ageCategories", msg: "An error occurred during checkout" },
        ];
      }

      setErrors(errorMessages);
    }
  };

  const getErrorMessage = (field) => {
    if (!Array.isArray(errors)) return null;

    const fieldError = errors.find((err) => err && err.path === field);
    if (!fieldError) return null;

    const msg = fieldError.msg;
    return msg ? String(msg) : null;
  };

  const clearErrorMessage = (field) => {
    setErrors((prevErrors) => prevErrors.filter((err) => err?.path !== field));
  };

  const handleAddToCart = () => {
    const currentUserId = loginData?.user?._id || "guest";

    setCart((prev) => {
      const updatedCart = { ...prev };

      if (!updatedCart[currentUserId]) {
        updatedCart[currentUserId] = [];
      }

      const itemExists = updatedCart[currentUserId].some(
        (cartItem) => cartItem?.experienceData?._id === data?._id
      );

      if (itemExists) {
        toast.error("This item is already in your cart.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: "red", color: "white" },
        });
        return prev;
      }

      updatedCart[currentUserId].push({
        ...cartData,
        experienceData: data,
        total,
        showInCart: true,
      });

      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;
    });

    setTimeout(() => {
      navigate("/my-cart");
    }, 200);
  };

  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.12)",
      }}
    >
      <Box sx={{ mb: 2, pb: 2, borderBottom: "1px solid #ECECEC" }}>
        {/* If there are valid time slots, show the dropdown selection, otherwise directly show age selection */}
        {data?.priceCategories?.some((slot) => slot.timeSlot.trim() !== "") ? (
          <>
            <Typography
              sx={{
                mb: 2,
                fontWeight: 700,
                color: theme.colors.text,
                fontSize: "20px",
              }}
            >
              Select Time Slot
            </Typography>

            <Box sx={{ width:"100%", mb: 3 }}>
              <Dropdown
                label=""
                placeholder="Select"
                value={cartData?.timeSlot || ""}
                onChange={handleTimeSlotChange}
                options={getTimeSlotOptions()}
                height="200px"
              />
            </Box>
          </>
        ) : (
          <>
            <Typography
              sx={{
                mb: 2,
                fontWeight: 700,
                color: theme.colors.text,
                fontSize: "20px",
              }}
            >
              Participants
            </Typography>

            {data?.priceCategories
              ?.flatMap((slot) => slot.prices)
              ?.map((price) => (
                <Box
                  key={price.age._id}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: theme.colors.textLight,
                      fontWeight: "400",
                      fontSize: "16px",
                    }}
                  >
                    {price.age.name}:
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <IconButton onClick={() => handleDecrement(price.age.name)}>
                      <RemoveIcon sx={{ color: theme.colors.orange }} />
                    </IconButton>
                    <Typography
                      sx={{
                        color: theme.colors.textLight,
                        mx: 1,
                        fontSize: "16px",
                        fontWeight: "400",
                      }}
                    >
                      {cartData.ageCounts[price.age.name] || 0}
                    </Typography>
                    <IconButton onClick={() => handleIncrement(price.age.name)}>
                      <AddIcon sx={{ color: theme.colors.orange }} />
                    </IconButton>
                  </Box>
                </Box>
              ))}
          </>
        )}

        {getErrorMessage("timeSlot") && (
          <Box color="red" mb={2}>
            {getErrorMessage("timeSlot")}
          </Box>
        )}
      </Box>

      {cartData.timeSlot && (
        <Typography
          sx={{
            mb: 2,
            color: theme.colors.text,
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          Participants
        </Typography>
      )}

      {cartData.timeSlot &&
        Object.keys(cartData.ageCounts).map((ageName) => (
          <Box
            key={ageName}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                color: theme.colors.textLight,
                fontWeight: "400",
                fontSize: "16px",
              }}
            >
              {ageName}:
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={() => handleDecrement(ageName)}>
                <RemoveIcon sx={{ color: theme.colors.orange }} />
              </IconButton>
              <Typography
                sx={{
                  color: theme.colors.textLight,
                  mx: 1,
                  fontSize: "16px",
                  fontWeight: "400",
                }}
              >
                {cartData.ageCounts[ageName]}
              </Typography>
              <IconButton onClick={() => handleIncrement(ageName)}>
                <AddIcon sx={{ color: theme.colors.orange }} />
              </IconButton>
            </Box>
          </Box>
        ))}

      {getErrorMessage("ageCategories") && (
        <Box color="red" mb={2}>
          {getErrorMessage("ageCategories")}
        </Box>
      )}

      {cartData.timeSlot && (
        <Box
          style={{
            borderBottom: "1px solid #ECECEC",
            marginBottom: "16px",
          }}
        />
      )}

      <Box sx={{ mb: 2, pb: 2, borderBottom: "1px solid #ECECEC" }}>
        <Typography
          sx={{
            mb: 2,
            fontWeight: 600,
            color: theme.colors.text,
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          Select Date
        </Typography>
        <CustomCalendar
          minDate={new Date(new Date().setDate(new Date().getDate() - 1))}
          onDateChange={handleDateChange}
          dateData={dateData}
        />
      </Box>

      <Typography
        sx={{
          mb: 2,
          fontWeight: 600,
          color: theme.colors.text,
          fontWeight: 700,
          fontSize: "20px",
        }}
      >
        Summary
      </Typography>
      <Box sx={{ mb: 2 }}>
        {cartData?.date && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              pb: 1,
              mb: 1,
            }}
          >
            <Typography sx={{ color: theme.colors.textLight, width: "50%" }}>
              Date
            </Typography>
            <Typography sx={{ color: theme.colors.textLight }}>
              {cartData?.date}
            </Typography>
          </Box>
        )}

        {Object.keys(cartData.ageCounts).map((ageName) => {
          const count = cartData.ageCounts[ageName];
          if (count > 0) {
            return (
              <Box
                key={ageName}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  pb: 1,
                  mb: 1,
                }}
              >
                <Typography
                  sx={{ color: theme.colors.textLight, width: "50%" }}
                >
                  {ageName}
                </Typography>
                <Typography
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    color: theme.colors.textLight,
                    width: "50%",
                  }}
                >
                  <span>{count}</span>
                  <span
                    style={{
                      color: theme.colors.text,
                      fontWeight: "700",
                      fontSize: "16px",
                    }}
                  >
                    {cartData.convertedsymbol}
                    {(count * getPrice(ageName)).toFixed(2)}
                  </span>
                </Typography>
              </Box>
            );
          }
          return null;
        })}

        <Box
          sx={{
            borderBottom: `1px solid ${theme.colors.lightGrey}`,
            mb: 2,
          }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: theme.colors.text, fontWeight: 600 }}
          >
            Total
          </Typography>
          <Typography
            variant="h6"
            sx={{ color: theme.colors.text, fontWeight: 600 }}
          >
            {cartData?.convertedsymbol}
            {total}
          </Typography>
        </Box>
      </Box>

      <Box ref={checkoutRef}>
        <CheckoutButton
          disabled={
            Object.values(cartData.ageCounts).every((count) => count === 0) ||
            !cartData.date
          }
          onClickCart={handleAddToCart}
          onClick={handleCheckout}
        />
      </Box>
    </Box>
  );
}

export default AddToCart;